import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { includes, get } from 'lodash';
import requester from 'utils/requester';
import api from 'config/api';
import { getIsLifecellFlag, getIsLoggedInSelector } from 'reducers/profile/selectors';
import { CONTENT_TYPES } from 'constants/content-types';
import { MISSING_SUBSCRIPTION } from 'constants/visibility-types';
import urlHelper, { resolvePlayerNavLink } from 'helpers/urlhelper';
import { navigateToPlayerPage } from 'actions/player';
import PLAYER_TYPES from 'constants/player-types';
import useModals from 'hooks/useModals';

export default () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const isLifecellUser = useSelector(getIsLifecellFlag);
  const { showLifecellPaymentModal } = useModals();

  const fetchChannelInfo = useCallback(
    async (channelID) => {
      const endpoint = urlHelper.getAuthorizedEndpointUrl(api.endpoints.channel, isLoggedIn);
      const channel = await requester({
        method: 'get',
        url: `${api.host}${endpoint}/${channelID}`,
      });
      return channel;
    },
    [isLoggedIn],
  );

  const onEnter = useCallback(
    async ({ detailsUrl = '' }, focusBackConfig) => {
      const url = detailsUrl.split('?')[0];
      if (!url) return;

      const itemIdFromUrl = url.split('/').pop();
      let route = '';

      if (includes(detailsUrl, 'asset')) {
        route = `/details/${CONTENT_TYPES.VOD_ASSET}/${itemIdFromUrl}`;
      } else if (includes(detailsUrl, 'tvSeries')) {
        route = `/details/${CONTENT_TYPES.TV_SERIES}/${itemIdFromUrl}`;
      } else if (includes(detailsUrl, 'carousel/elements')) {
        route = `/list-grid/${itemIdFromUrl}`;
      } else if (includes(detailsUrl, 'channel')) {
        const channelID = get(detailsUrl.match(/\/channel\/(\d+)/), [1]);
        const channel = await fetchChannelInfo(channelID);

        const goToPlayer = () =>
          dispatch(
            navigateToPlayerPage({
              item: { id: channelID },
              type: PLAYER_TYPES.CHANNEL,
            }),
          );

        if (isLoggedIn && channelID) {
          if (channel.visibilityDetails === MISSING_SUBSCRIPTION) {
            const onSuccess = resolvePlayerNavLink(
              { id: channel.id },
              { type: PLAYER_TYPES.CHANNEL, isVodChannel: !!channel.isVod },
            );

            if (isLifecellUser) {
              showLifecellPaymentModal({ id: channelID, type: 'channelId', onSuccess: goToPlayer }, focusBackConfig);
              return;
            }
            return history.push({
              pathname: '/profile/packages/filter',
              search: `?channelId=${channelID}&onSuccess=${onSuccess}`,
            });
          }

          goToPlayer();
          return;
        }
        route = '/player/channel/';
      }

      if (route) history.push(route);
    },
    [dispatch, fetchChannelInfo, history, isLifecellUser, isLoggedIn, showLifecellPaymentModal],
  );

  return onEnter;
};
